export const calculate_qty_depending_on_type = (type, qty, boxes=0) => {
    qty = Number(qty);

    switch (type) {
        case "box":
            return {
                total: qty * Number(boxes),
                type: "piece"
            };

        case "KG":
            return {
                total: qty * 1000,
                type: "G"
            };

        case "piece":
            return {
                total: qty,
                type: "piece"
            };

        case "G":
            return {
                total: qty,
                type: "G"
            };

        default:
            return {
                total: 0,
                type: null
            };
    }
};